module.exports = __webpack_public_path__ + "img/product-smoke-3.3c6f58e1.jpg";